export const actionTypes = {
  SHOW_MODAL: 'APP.ACCESSIBILITY.SHOW_MODAL',
  HIDE_MODAL: 'APP.ACCESSIBILITY.HIDE_MODAL',
  SET_BODY_CLASS: 'APP.ACCESSIBILITY.SET_BODY_CLASS',
};

export function showModal() {
  return {
    type: actionTypes.SHOW_MODAL,
  };
}

export function hideModal() {
  return {
    type: actionTypes.HIDE_MODAL,
  };
}

export function setBodyClass(data) {
  return {
    type: actionTypes.SET_BODY_CLASS,
    payload: data,
  };
}
